import {createContext, Context} from "react";
import {
    signIn,
    confirmSignIn,
    signUp,
    confirmSignUp,
    signOut,
    resetPassword,
    confirmResetPassword,
    updatePassword
} from "@aws-amplify/auth";
import {signInWithRedirect} from "@aws-amplify/auth";

export type AuthState = "initialising" | "authenticated" | "unauthenticated" | "confirm_sign_in_with_new_password"

export type SignUpInput<UserAttributes> = {
    email: string
    password: string
    attributes: UserAttributes
}

export type AuthContextType<UserAttributes> = {
    state: AuthState
    signIn: typeof signIn
    signInWithRedirect: typeof signInWithRedirect
    confirmSignIn: typeof confirmSignIn,
    signUp: (input: SignUpInput<UserAttributes>) => ReturnType<typeof signUp>,
    confirmSignUp: typeof confirmSignUp
    signOut: typeof signOut
    resetPassword: typeof resetPassword,
    confirmResetPassword: typeof confirmResetPassword,
    updatePassword: typeof updatePassword,
    updateUserAttributes: (input: Partial<UserAttributes>) => Promise<void>,
    signUpUsername?: string
    accessToken?: string
    username?: string
    userAttributes?: UserAttributes
}

export const createAuthContext = <UserAttributes>(): Context<AuthContextType<UserAttributes>> =>
    createContext<AuthContextType<UserAttributes>>({
        state: "initialising" as AuthState,
        signIn,
        signInWithRedirect,
        confirmSignIn,
        signUp: () => Promise.resolve({} as ReturnType<typeof signUp>),
        confirmSignUp,
        signOut,
        resetPassword,
        confirmResetPassword,
        updatePassword,
        updateUserAttributes: () => Promise.resolve(),
    })

